import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_InvoiceProductsDialog = _resolveComponent("InvoiceProductsDialog")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_editCompany = _resolveComponent("editCompany")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UploadDocument = _resolveComponent("UploadDocument")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center",
        style: {"height":"8vh"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_back, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                "data-cy": "EngagementLetter-button-back"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "7",
            class: "headline mb-5 d-flex align-center"
          }, {
            default: _withCtx(() => _cache[54] || (_cache[54] = [
              _createTextVNode("Lettre de mission")
            ])),
            _: 1
          }),
          (_ctx.data.status === 'DRAFT')
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "4",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    elevation: "0",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                    class: "mx-1",
                    size: "small",
                    "data-cy": "Engagement-save"
                  }, {
                    default: _withCtx(() => _cache[55] || (_cache[55] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    elevation: "0",
                    disabled: !_ctx.isValid,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validate())),
                    class: "mx-1",
                    "data-cy": "EngagementLetters-valid",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                      _createTextVNode(" Valider ")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }))
            : (_ctx.data.status === 'VALIDATED')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "4",
                  class: "d-flex justify-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      elevation: "0",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modify())),
                      class: "mx-1",
                      "data-cy": "EngagementLetters-modif",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                        _createTextVNode(" Modifier ")
                      ])),
                      _: 1
                    }),
                    (_ctx.localEnv !== 'production')
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          variant: "outlined",
                          elevation: "0",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.askForSignature())),
                          class: "mx-1",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[58] || (_cache[58] = [
                            _createTextVNode(" Signer ")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      disabled: !_ctx.isValid,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPDF())),
                      class: "mx-1",
                      "data-cy": "EngagementLetters-downloadPDF",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[59] || (_cache[59] = [
                        _createTextVNode(" Télécharger le PDF ")
                      ])),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      disabled: !_ctx.isValid,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printDocx())),
                      class: "mx-1",
                      "data-cy": "EngagementLetters-downloadDocx",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[60] || (_cache[60] = [
                        _createTextVNode(" Télécharger le Docx ")
                      ])),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      elevation: "0",
                      disabled: !_ctx.isValid,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogUploadSignedDocument = true)),
                      class: "mx-1",
                      "data-cy": "EngagementLetters-signe",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[61] || (_cache[61] = [
                        _createTextVNode(" Signée ! ")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }))
              : (_ctx.data.status === 'SIGNED')
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 2,
                    cols: "4",
                    class: "d-flex justify-end ml-5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        elevation: "0",
                        disabled: !_ctx.isValid,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPDF())),
                        class: "mx-1",
                        "data-cy": "EngagementLetters-downloadPDFSigne",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[62] || (_cache[62] = [
                          _createTextVNode(" Télécharger le PDF ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "15" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "default_card",
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "py-2 px-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tabs, {
                            modelValue: _ctx.step,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step) = $event)),
                            direction: "vertical",
                            "background-color": "rgba(0,0,0,0)",
                            class: "fill-height"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tab, {
                                value: "0",
                                "data-cy": "EngagementLetters-societyClient",
                                style: {"justify-content":"center"}
                              }, {
                                default: _withCtx(() => _cache[63] || (_cache[63] = [
                                  _createTextVNode(" Société / Client ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_tab, {
                                value: "1",
                                "data-cy": "EngagementLetters-cebinetContrat",
                                style: {"justify-content":"center"}
                              }, {
                                default: _withCtx(() => _cache[64] || (_cache[64] = [
                                  _createTextVNode(" Cabinet / Contrat ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_tab, {
                                value: "2",
                                "data-cy": "EngagementLetters-tarification",
                                style: {"justify-content":"center"}
                              }, {
                                default: _withCtx(() => _cache[65] || (_cache[65] = [
                                  _createTextVNode(" Tarification ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_tab, {
                                value: "3",
                                "data-cy": "EngagementLetters-travaux",
                                style: {"justify-content":"center"}
                              }, {
                                default: _withCtx(() => _cache[66] || (_cache[66] = [
                                  _createTextVNode(" Répartition des Travaux ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "15" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tabs_window, {
                            modelValue: _ctx.step,
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.step) = $event)),
                            class: "pa-4",
                            style: {"background":"rgba(0, 0, 0, 0)"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_window_item, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "pr-2 pb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[69] || (_cache[69] = _createElementVNode("span", { class: "title" }, " Société prospectée ", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl fill-height",
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.accessDialogCompany())),
                                            readonly: !_ctx.isEditable,
                                            elevation: "0",
                                            ripple: _ctx.isEditable
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, {
                                                "primary-title": "",
                                                style: {"padding-top":"5px","padding-bottom":"5px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "8",
                                                        "data-cy": "EngagementLetter-companyName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.data.prospectedCompany.name), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "4",
                                                        class: "d-flex justify-end"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.isEditable)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                elevation: "0",
                                                                "data-cy": "EngagementLetter-edit",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _cache[68] || (_cache[68] = _createTextVNode(" éditer ")),
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "small",
                                                                    location: "end"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                                      _createTextVNode("$edit")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: _normalizeClass({
                                                                'text-red':
                                                                    !_ctx.data.prospectedCompany.siret,
                                                            }),
                                                        "data-cy": "EngagementLetter-siret"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Siret: " + _toDisplayString(_ctx.getSiretValue(
                                                                    _ctx.data.prospectedCompany.siret,
                                                                ) || "manquant"), 1)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["class"]),
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: _normalizeClass({
                                                                'text-red':
                                                                    !_ctx.data.prospectedCompany
                                                                        .address ||
                                                                    !_ctx.data.prospectedCompany
                                                                        .postalCode ||
                                                                    !_ctx.data.prospectedCompany.city,
                                                            }),
                                                        "data-cy": "EngagementLetter-adress"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Adresse: " + _toDisplayString(_ctx.data.prospectedCompany.address) + " " + _toDisplayString(_ctx.data.prospectedCompany.postalCode) + " " + _toDisplayString(_ctx.data.prospectedCompany.city), 1)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["class"]),
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: _normalizeClass({
                                                                'text-red':
                                                                    !_ctx.data.prospectedCompany
                                                                        .legalForm,
                                                            }),
                                                        "data-cy": "EngagementLetter-legalForm"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.$t("settings.legalForm")) + ": " + _toDisplayString(_ctx.data.prospectedCompany.legalForm ||
                                                                "manquant"), 1)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["class"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["readonly", "ripple"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        class: "pl-2 pb-2",
                                        cols: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[70] || (_cache[70] = _createElementVNode("span", { class: "title" }, "Client prospecté", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl fill-height",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "12" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_radio_group, {
                                                            class: "my-0 py-0",
                                                            color: "primary",
                                                            modelValue: 
                                                                    _ctx.data.prospectedClient.gender
                                                                ,
                                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((
                                                                    _ctx.data.prospectedClient.gender
                                                                ) = $event)),
                                                            readonly: !_ctx.isEditable,
                                                            inline: ""
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_radio, {
                                                                class: "my-0 py-0",
                                                                label: "Homme",
                                                                value: 'man',
                                                                "data-cy": "EngagementLetter-man"
                                                              }),
                                                              _createVNode(_component_v_radio, {
                                                                class: "my-0 py-0",
                                                                label: "Femme",
                                                                value: 'woman'
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "mb-1 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedClient.firstname
                                                                ,
                                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                                                                    _ctx.data.prospectedClient.firstname
                                                                ) = $event)),
                                                            label: "Prénom",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-fistName",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "mb-1 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedClient.lastname
                                                                ,
                                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((
                                                                    _ctx.data.prospectedClient.lastname
                                                                ) = $event)),
                                                            label: "Nom",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-lastName",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "mt-1 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedClient
                                                                        .phoneNumber
                                                                ,
                                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((
                                                                    _ctx.data.prospectedClient
                                                                        .phoneNumber
                                                                ) = $event)),
                                                            label: "Numero de téléphone",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-phone",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "mt-1 px-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedClient.email
                                                                ,
                                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((
                                                                    _ctx.data.prospectedClient.email
                                                                ) = $event)),
                                                            label: "Email",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-email",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "pr-2 pt-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[71] || (_cache[71] = _createElementVNode("div", { class: "title" }, " Informations complémentaires sur la société ", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mb-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .activityDetails
                                                                ,
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .activityDetails
                                                                ) = $event)),
                                                            label: "Détail de l'activité",
                                                            readonly: !_ctx.isEditable,
                                                            outlined: "",
                                                            "hide-details": "",
                                                            density: "compact",
                                                            "data-cy": "EngagementLetter-activityDetails"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "my-1 pr-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_date_picker_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .establishmentDate
                                                                ,
                                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .establishmentDate
                                                                ) = $event)),
                                                            label: 'Date de création de la société',
                                                            readonly: !_ctx.isEditable,
                                                            textFieldReadOnly: false,
                                                            "hide-details": "",
                                                            prefixDataCy: "EngagementLetter-creation"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "my-1 pl-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_date_picker_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .endFinancialYear
                                                                ,
                                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .endFinancialYear
                                                                ) = $event)),
                                                            label: 'Date de fin d\'exercice',
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            prefixDataCy: "EngagementLetter-endFinancial"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "my-1 pr-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .shareCapital
                                                                ,
                                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .shareCapital
                                                                ) = $event)),
                                                            label: 'Montant du capital social',
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "auto",
                                                            "data-cy": "EngagementLetter-shareCapital"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "my-1 pl-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .numberOfEmployees
                                                                ,
                                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .numberOfEmployees
                                                                ) = $event)),
                                                            label: 'Nombre de salarié(s)',
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "auto",
                                                            density: "compact",
                                                            "data-cy": "EngagementLetter-numberOfEmployees"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "my-1 pr-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .forecastTurnover
                                                                ,
                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .forecastTurnover
                                                                ) = $event)),
                                                            label: 'Chiffre d\'affaires prévisionnel',
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "auto",
                                                            "data-cy": "EngagementLetter-forecastTurnover"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "my-1 pl-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .lastYearTurnover
                                                                ,
                                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .lastYearTurnover
                                                                ) = $event)),
                                                            label: 'Chiffre d\'affaires année N-1',
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "auto",
                                                            "data-cy": "EngagementLetter-lastYearTurnover"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "mt-1 pr-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .estimatedNumberOfInvoice
                                                                ,
                                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .estimatedNumberOfInvoice
                                                                ) = $event)),
                                                            label: "Estimation du nb de factures par an",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            density: "compact",
                                                            "data-cy": "EngagementLetter-estimatedNumberOfInvoice"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "mt-1 pl-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: 
                                                                    _ctx.data.prospectedCompany
                                                                        .numberOfBankAccount
                                                                ,
                                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((
                                                                    _ctx.data.prospectedCompany
                                                                        .numberOfBankAccount
                                                                ) = $event)),
                                                            label: "Nb de compte(s) bancaire(s)",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            density: "compact",
                                                            "data-cy": "EngagementLetter-numberOfBankAccount"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, { value: "1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pr-2 pb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[72] || (_cache[72] = _createElementVNode("span", { class: "title" }, "Contrat", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mb-1 mx-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_date_picker_filled, {
                                                            modelValue: _ctx.data.contractBegin,
                                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.data.contractBegin) = $event)),
                                                            label: 'Date de début du contrat',
                                                            readonly: !_ctx.isEditable,
                                                            textFieldReadOnly: false,
                                                            "hide-details": "",
                                                            prefixDataCy: "EngagementLetter-beginContrat"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mt-1 mx-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_date_picker_filled, {
                                                            modelValue: _ctx.data.contractEnd,
                                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.data.contractEnd) = $event)),
                                                            label: 'Date de fin du contrat',
                                                            readonly: !_ctx.isEditable,
                                                            textFieldReadOnly: false,
                                                            "hide-details": "",
                                                            prefixDataCy: "EngagementLetter-endContrat"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pl-2 pb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[73] || (_cache[73] = _createElementVNode("span", { class: "title" }, "Réalisation du contrat", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mb-1 mx-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: _ctx.data.localizationCreation,
                                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.data.localizationCreation) = $event)),
                                                            label: "Fait à ...",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-ville",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mt-1 mx-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_date_picker_filled, {
                                                            modelValue: _ctx.data.contractDateCreation,
                                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.data.contractDateCreation) = $event)),
                                                            label: 'En date du ...',
                                                            readonly: !_ctx.isEditable,
                                                            textFieldReadOnly: false,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-dateCreation"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "pt-2 pr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[74] || (_cache[74] = _createElementVNode("span", { class: "title" }, "Expert-comptable", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mb-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: _ctx.data.accountant.firstname,
                                                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.data.accountant.firstname) = $event)),
                                                            label: "Prénom",
                                                            readonly: "",
                                                            "hide-details": "",
                                                            density: "compact",
                                                            "data-cy": "EngagementLetter-accountantFirstName"
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "mt-1"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: _ctx.data.accountant.lastname,
                                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.data.accountant.lastname) = $event)),
                                                            label: "Nom",
                                                            readonly: "",
                                                            "hide-details": "",
                                                            density: "compact",
                                                            "data-cy": "EngagementLetter-accountantLastName"
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_ctx.isEditable)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            cols: "12",
                                                            class: "py-2"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_divider)
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.isEditable)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            cols: "12",
                                                            style: {"max-height":"45vh","overflow-y":"auto"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_select_user, {
                                                                class: "px-1",
                                                                modelValue: _ctx.data.accountant,
                                                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.data.accountant) = $event)),
                                                                companyId: _ctx.companyId,
                                                                type: 'NATURAL_PERSON'
                                                              }, null, 8, ["modelValue", "companyId"])
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "pt-2 pl-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[75] || (_cache[75] = _createElementVNode("span", { class: "title" }, "Condition de fin de contrat", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "12" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_switch, {
                                                            modelValue: 
                                                                    _ctx.data.cg_endOfContractCondition
                                                                ,
                                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((
                                                                    _ctx.data.cg_endOfContractCondition
                                                                ) = $event)),
                                                            readonly: !_ctx.isEditable,
                                                            label: "Pénalités si rupture après préavis 3 mois",
                                                            "data-cy": "EngagementLetter-penality"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, { cols: "12" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_select_filled, {
                                                            modelValue: _ctx.data.commercialCourt,
                                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.data.commercialCourt) = $event)),
                                                            items: _ctx.commercialCourts,
                                                            "item-value": "value",
                                                            "item-title": "text",
                                                            "return-object": "",
                                                            readonly: !_ctx.isEditable,
                                                            label: "Tribunal de commerce",
                                                            "data-cy": "EngagementLetter-commerce",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "items", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _cache[76] || (_cache[76] = _createElementVNode("span", { class: "title mt-3" }, "Contact du cabinet", -1)),
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", null, [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.data.accounting_phoneNumber,
                                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.data.accounting_phoneNumber) = $event)),
                                                      label: "Numero de téléphone",
                                                      readonly: !_ctx.isEditable,
                                                      "hide-details": "",
                                                      "data-cy": "EngagementLetter-telephone",
                                                      density: "compact"
                                                    }, null, 8, ["modelValue", "readonly"])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_1, [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.data.accounting_email,
                                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.data.accounting_email) = $event)),
                                                      label: "Email",
                                                      readonly: !_ctx.isEditable,
                                                      "hide-details": "",
                                                      "data-cy": "EngagementLetter-mail",
                                                      density: "compact"
                                                    }, null, 8, ["modelValue", "readonly"])
                                                  ])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, { value: "2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl mb-4",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                  _createTextVNode(" Frais de dossier ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "d-flex px-2 pb-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: _ctx.data.applicationFee,
                                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.data.applicationFee) = $event)),
                                                            modelModifiers: { number: true },
                                                            "append-inner-icon": "$fa-percent",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            dense: "",
                                                            "data-cy": "EngagementLetter-fraisDossier"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl mb-4",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                  _createTextVNode(" Type de facturation ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "d-flex px-2 pb-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_select_filled, {
                                                            modelValue: _ctx.data.reccurency,
                                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.data.reccurency) = $event)),
                                                            items: _ctx.reccurencyTypes,
                                                            "item-title": "text",
                                                            "item-value": "value",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-facturation",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "items", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "px-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl mb-4",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                  _createTextVNode(" Délai de paiement ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "d-flex px-2 pb-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field_filled, {
                                                            modelValue: _ctx.data.paymentDelay,
                                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.data.paymentDelay) = $event)),
                                                            modelModifiers: { number: true },
                                                            "append-inner-icon": "$oss-calendar",
                                                            label: "Nombre de jours",
                                                            readonly: !_ctx.isEditable,
                                                            "hide-details": "",
                                                            "data-cy": "EngagementLetter-days",
                                                            density: "compact"
                                                          }, null, 8, ["modelValue", "readonly"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, { "tree-line": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item, {
                                                active: false,
                                                link: false
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_row, {
                                                    "no-gutters": "",
                                                    style: {"width":"132px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        class: "d-flex align-center justify-start"
                                                      }, {
                                                        default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                          _createTextVNode(" Annuelle ")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "8" }, {
                                                        default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                          _createTextVNode(" Intitulé de la prestation ")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "4",
                                                        class: "d-flex"
                                                      }, {
                                                        default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                          _createTextVNode(" Montant (HT) ")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.items, (item, index) => {
                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: index,
                                                  active: false,
                                                  link: false
                                                }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "6",
                                                          class: "d-flex align-center justify-center px-4 py-1"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_switch, {
                                                              modelValue: item.annualPayment,
                                                              "onUpdate:modelValue": ($event: any) => ((item.annualPayment) = $event),
                                                              class: "my-0",
                                                              readonly: !_ctx.isEditable,
                                                              "hide-details": "",
                                                              "data-cy": `EngagementLetter-annualPayment-${index}`
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "data-cy"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "6",
                                                          class: "d-flex align-center justify-center pl-4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_ctx.isEditable)
                                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                  key: 0,
                                                                  icon: "$delete",
                                                                  onClick: ($event: any) => (_ctx.deleteItem(index)),
                                                                  "data-cy": `EngagementLetter-delete-${index}`
                                                                }, null, 8, ["onClick", "data-cy"]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { cols: "8" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field_filled, {
                                                              modelValue: item.title,
                                                              "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                                                              readonly: !_ctx.isEditable,
                                                              outlined: "",
                                                              "hide-details": "",
                                                              density: "compact",
                                                              "data-cy": `EngagementLetter-title-${index}`
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "data-cy"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "4",
                                                          class: "d-flex align-center pl-10"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_text_field, {
                                                              modelValue: item.amount,
                                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                              readonly: !_ctx.isEditable,
                                                              "content-class": "mr-3",
                                                              min: '0',
                                                              "hide-details": "",
                                                              "data-cy": `EngagementLetter-amount-${index}`
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "data-cy"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128)),
                                              (_ctx.isEditable)
                                                ? (_openBlock(), _createBlock(_component_InvoiceProductsDialog, {
                                                    key: 0,
                                                    companyId: _ctx.companyId,
                                                    onValid: _cache[39] || (_cache[39] = ($event: any) => (_ctx.addProduct($event))),
                                                    "data-cy": "EngagementLetter-valider"
                                                  }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_list_item, _mergeProps({
                                                        ripple: "",
                                                        class: "mx-3 rounded-xl",
                                                        border: ""
                                                      }, props, { "data-cy": "EngagementLetter-addLigne" }), {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { color: "primary" }, {
                                                            default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                              _createTextVNode(" $add ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                class: "d-flex justify-center"
                                                              }, {
                                                                default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                                  _createTextVNode(" Ajouter une ligne ")
                                                                ])),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1040)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["companyId"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "pt-4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            class: "inside_card rounded-xl",
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "6" }, {
                                                        default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                          _createTextVNode(" Tarif mensuel ")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "6",
                                                        class: "d-flex justify-end px-2 pb-2",
                                                        "data-cy": "EngagementLetter-total"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    _ctx.totalPrice,
                                                                    undefined,
                                                                )), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, { value: "3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "7",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => _cache[86] || (_cache[86] = [
                                          _createElementVNode("span", { class: "title" }, "Description du périmètre d’intervention | Répartition des travaux", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_switch, {
                                            modelValue: _ctx.taskDistributionBobbeeMode,
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.taskDistributionBobbeeMode) = $event)),
                                            "hide-details": "",
                                            label: "Distribution des tâches façon bobbee",
                                            class: "my-0"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.taskDistributionBobbeeMode)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            cols: "12",
                                            key: _ctx.update
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "1",
                                                    class: "d-flex justify-end align-center pr-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: "\n                                                            $fa-chevron-up\n                                                        ",
                                                        size: "small",
                                                        disabled: _ctx.panel === 0 || _ctx.panelIsNaN,
                                                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.panel--))
                                                      }, null, 8, ["disabled"]),
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: "\n                                                            $fa-chevron-down\n                                                        ",
                                                        disabled: 
                                                            _ctx.panel ===
                                                                _ctx.data.taskDistribution.length - 1 ||
                                                            _ctx.panelIsNaN
                                                        ,
                                                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.panel++)),
                                                        "data-cy": "Engagement-nextTask"
                                                      }, null, 8, ["disabled"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_expansion_panels, {
                                                        accordion: "",
                                                        flat: "",
                                                        modelValue: _ctx.panel,
                                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.panel) = $event))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.taskDistribution, (task, i) => {
                                                            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                                              key: i,
                                                              style: {"background":"transparent"}
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_expansion_panel_title, { class: "primary--text" }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t(
                                                                        "engagementLetter.wordings." +
                                                                            task.name,
                                                                    )), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_card, {
                                                                      class: "rounded-xl",
                                                                      elevation: "0",
                                                                      style: {"overflow":"hidden"}
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_row, {
                                                                          "no-gutters": "",
                                                                          class: "d-flex justify-center"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list, {
                                                                                  style: {"background-color":"transparent"},
                                                                                  lines: "two"
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.subs, (item) => {
                                                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                                        key: 
                                                                                        'a_' +
                                                                                        item.name
                                                                                    ,
                                                                                        ripple: "",
                                                                                        rounded: "",
                                                                                        class: "oss-list-item"
                                                                                      }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                                            default: _withCtx(() => [
                                                                                              _createVNode(_component_v_col, {
                                                                                                cols: "8",
                                                                                                class: "d-flex align-center"
                                                                                              }, {
                                                                                                default: _withCtx(() => [
                                                                                                  _createTextVNode(_toDisplayString(_ctx.$t(
                                                                                                        "engagementLetter.wordings." +
                                                                                                            item.name,
                                                                                                    )), 1)
                                                                                                ]),
                                                                                                _: 2
                                                                                              }, 1024),
                                                                                              _createVNode(_component_v_col, {
                                                                                                cols: "4",
                                                                                                class: "d-flex align-center justify-center"
                                                                                              }, {
                                                                                                default: _withCtx(() => [
                                                                                                  (
                                                                                                        item.included
                                                                                                    )
                                                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                                        _createTextVNode(" Inclus ")
                                                                                                      ], 64))
                                                                                                    : (
                                                                                                        item.isDefinable
                                                                                                    )
                                                                                                      ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                                                                                          key: 1,
                                                                                                          color: "primary",
                                                                                                          modelValue: 
                                                                                                            item.realizedBy
                                                                                                        ,
                                                                                                          "onUpdate:modelValue": ($event: any) => ((
                                                                                                            item.realizedBy
                                                                                                        ) = $event),
                                                                                                          class: "my-0 py-0",
                                                                                                          disabled: 
                                                                                                            item.included
                                                                                                        ,
                                                                                                          readonly: 
                                                                                                            !_ctx.isEditable
                                                                                                        ,
                                                                                                          inline: "",
                                                                                                          "hide-details": ""
                                                                                                        }, {
                                                                                                          default: _withCtx(() => [
                                                                                                            _createVNode(_component_v_radio, {
                                                                                                              class: "my-0 py-0",
                                                                                                              label: "Client",
                                                                                                              value: 'customer',
                                                                                                              "data-cy": 
                                                                                                                'EngagementLetter-' +
                                                                                                                i +
                                                                                                                '-' +
                                                                                                                _ctx.$t(
                                                                                                                    'engagementLetter.wordings.' +
                                                                                                                        item.name,
                                                                                                                ).split(
                                                                                                                    ' ',
                                                                                                                )[0] +
                                                                                                                '-customer'
                                                                                                            
                                                                                                            }, null, 8, ["data-cy"]),
                                                                                                            _createVNode(_component_v_radio, {
                                                                                                              class: "my-0 py-0",
                                                                                                              label: "Cabinet",
                                                                                                              value: 'accountant',
                                                                                                              "data-cy": 
                                                                                                                'EngagementLetter-' +
                                                                                                                i +
                                                                                                                '-' +
                                                                                                                _ctx.$t(
                                                                                                                    'engagementLetter.wordings.' +
                                                                                                                        item.name,
                                                                                                                ).split(
                                                                                                                    ' ',
                                                                                                                )[0] +
                                                                                                                '-Cabinet'
                                                                                                            
                                                                                                            }, null, 8, ["data-cy"])
                                                                                                          ]),
                                                                                                          _: 2
                                                                                                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "readonly"]))
                                                                                                      : _createCommentVNode("", true)
                                                                                                ]),
                                                                                                _: 2
                                                                                              }, 1024)
                                                                                            ]),
                                                                                            _: 2
                                                                                          }, 1024)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024))
                                                                                    }), 128))
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: "12"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, { style: {"background-color":"transparent"} }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.taskDistribution, (item, index) => {
                                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                                      key: 'a_' + index,
                                                      class: "oss-list-item",
                                                      ripple: "",
                                                      density: "compact"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, {
                                                          "no-gutters": "",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (item.custom)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createVNode(_component_v_col, {
                                                                    cols: 
                                                                        +_ctx.getWidth(
                                                                            item.spaceNumber,
                                                                        ) - 2
                                                                    ,
                                                                    class: "pr-2 d-flex align-center"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_text_field_filled, {
                                                                        modelValue: item.name,
                                                                        "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                                                                        label: "Nom de la tache",
                                                                        outlined: "",
                                                                        "hide-details": "",
                                                                        density: "compact"
                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["cols"]),
                                                                  _createVNode(_component_v_col, {
                                                                    cols: "2",
                                                                    class: "d-flex justify-space-between align-center"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_col, {
                                                                            cols: "12",
                                                                            class: "d-flex justify-center align-center"
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_btn_icon, {
                                                                                icon: "$fa-chevron-left",
                                                                                outlined: "",
                                                                                rounded: "",
                                                                                class: "mx-1",
                                                                                onClick: ($event: any) => (
                                                                                    item.spaceNumber--
                                                                                ),
                                                                                disabled: 
                                                                                    item.spaceNumber ===
                                                                                    0
                                                                                
                                                                              }, null, 8, ["onClick", "disabled"]),
                                                                              _createVNode(_component_v_btn_icon, {
                                                                                icon: "$fa-chevron-right",
                                                                                outlined: "",
                                                                                rounded: "",
                                                                                class: "mx-1",
                                                                                onClick: ($event: any) => (
                                                                                    item.spaceNumber++
                                                                                ),
                                                                                disabled: 
                                                                                    item.spaceNumber ===
                                                                                    2
                                                                                
                                                                              }, null, 8, ["onClick", "disabled"]),
                                                                              _createVNode(_component_v_btn_icon, {
                                                                                icon: "$delete",
                                                                                outlined: "",
                                                                                rounded: "",
                                                                                class: "mx-1",
                                                                                onClick: ($event: any) => (
                                                                                    _ctx.deleteTaskDistributionLine(
                                                                                        index,
                                                                                    )
                                                                                ),
                                                                                size: "small"
                                                                              }, null, 8, ["onClick"])
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024),
                                                                          _createVNode(_component_v_col, {
                                                                            cols: "12",
                                                                            class: "d-flex justify-center align-center"
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_switch, {
                                                                                modelValue: 
                                                                                    item.isDefinable
                                                                                ,
                                                                                "onUpdate:modelValue": ($event: any) => ((
                                                                                    item.isDefinable
                                                                                ) = $event),
                                                                                "hide-details": "",
                                                                                label: "Selectionnable",
                                                                                class: "mt-0 pt-0 pr-1"
                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ], 64))
                                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                                  key: 1,
                                                                  cols: _ctx.getWidth(item.spaceNumber),
                                                                  class: "d-flex align-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t(
                                                                        "engagementLetter.wordings." +
                                                                            item.name,
                                                                    )), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["cols"])),
                                                            _createVNode(_component_v_col, {
                                                              cols: "4",
                                                              class: "d-flex align-center justify-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (item.isDefinable)
                                                                  ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                                                      key: 0,
                                                                      color: "primary",
                                                                      modelValue: item.realizedBy,
                                                                      "onUpdate:modelValue": ($event: any) => ((item.realizedBy) = $event),
                                                                      class: "my-0 py-0",
                                                                      disabled: item.included,
                                                                      readonly: !_ctx.isEditable,
                                                                      inline: "",
                                                                      "hide-details": ""
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "my-0 py-0",
                                                                          label: "Client",
                                                                          value: 'customer'
                                                                        }),
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "my-0 py-0",
                                                                          label: "Cabinet",
                                                                          value: 'accountant'
                                                                        })
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "readonly"]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128)),
                                                  _createVNode(_component_v_list_item, {
                                                    ripple: "",
                                                    class: "mt-2",
                                                    "two-line": "",
                                                    onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.newTaskDistributionLine())),
                                                    density: "compact"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, {
                                                        "no-gutters": "",
                                                        class: "d-flex justify-end"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, {
                                                            cols: "8",
                                                            class: "d-flex align-center justify-center"
                                                          }, {
                                                            default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                              _createTextVNode(" Ajouter un élement ")
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "4",
                                                            class: "d-flex align-center justify-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                                default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                                  _createTextVNode("$add")
                                                                ])),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.dialogProspectedCompany && _ctx.isEditable)
                    ? (_openBlock(), _createBlock(_component_oss_dialog, {
                        key: 0,
                        modelValue: _ctx.dialogProspectedCompany,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.dialogProspectedCompany) = $event)),
                        title: 'Choisir un client',
                        onClose: _cache[49] || (_cache[49] = ($event: any) => (_ctx.selectCompanyWindow = 0)),
                        onValid: _ctx.validCompany,
                        "hide-valid": _ctx.selectCompanyWindow !== 1,
                        prefixDataCy: "EngagementLetter-client",
                        width: "60vw"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window, {
                            modelValue: _ctx.selectCompanyWindow,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.selectCompanyWindow) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_window_item, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_company_table, {
                                    showGenericCompany: false,
                                    showCustomerCompanies: true,
                                    showExistingCompanies: false,
                                    company: 
                                        _ctx.data.prospectedCompany ? _ctx.data.prospectedCompany.name : ''
                                    ,
                                    siret: 
                                        _ctx.data.prospectedCompany ? _ctx.data.prospectedCompany.siret : ''
                                    ,
                                    siren: 
                                        _ctx.data.prospectedCompany ? _ctx.data.prospectedCompany.siren : ''
                                    ,
                                    vatNumber: 
                                        _ctx.data.prospectedCompany
                                            ? _ctx.data.prospectedCompany.vatNumber
                                            : ''
                                    ,
                                    parentCompanyId: _ctx.companyId,
                                    onSelectCompany: _cache[46] || (_cache[46] = ($event: any) => (_ctx.selectProspectedCompany($event))),
                                    "data-cy": "test"
                                  }, null, 8, ["company", "siret", "siren", "vatNumber", "parentCompanyId"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_window_item, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_editCompany, {
                                    ref: "editCompany",
                                    adminMode: true,
                                    "in-company": _ctx.data.prospectedCompany,
                                    onUpdated: _ctx.closeDialogProspectedCompany
                                  }, null, 8, ["in-company", "onUpdated"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onValid", "hide-valid"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.dialogUploadSignedDocument,
            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.dialogUploadSignedDocument) = $event)),
            title: "Importer la lettre de mission signée par le client",
            onValid: _cache[53] || (_cache[53] = ($event: any) => ((_ctx.$refs.uploadDocument as any).functionButton())),
            "max-width": "60vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocument, {
                ref: "uploadDocument",
                showFirstPrevious: false,
                companyId: _ctx.companyId,
                documentId: _ctx.documentId,
                documentType: 'MISCELLANEOUS',
                multiple: false,
                freeTag: false,
                showBtn: true,
                onFileUploaded: _cache[50] || (_cache[50] = ($event: any) => (_ctx.signed())),
                onNewDocument: _cache[51] || (_cache[51] = ($event: any) => (_ctx.attachDocumentToEngagementLetter($event)))
              }, null, 8, ["companyId", "documentId"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}